var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoIdentity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 74,
    viewBox: "0 0 66 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.5001 43.37C65.5001 29.1678 55.529 11.8983 43.2307 4.79817C37.0195 1.21187 31.4112 0.91047 27.3632 3.31405L16.6997 9.48516L20.967 17.1213V17.6573C20.967 31.642 30.6386 48.5758 42.6737 55.8743L47.4675 64.4299L58.8921 57.8373C62.9668 55.5252 65.4982 50.5197 65.4982 43.37H65.5001Z",
    fill: "url(#paint0_linear_29_230391)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7401 64.2759C56.4362 59.2553 56.4354 42.9737 47.7384 27.9101C39.0414 12.8465 24.9416 4.70505 16.2456 9.72571C7.54952 14.7464 7.5503 31.0279 16.2473 46.0915C24.9443 61.1551 39.0441 69.2966 47.7401 64.2759Z",
    fill: "url(#paint1_linear_29_230391)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.627 62.3481C54.709 57.682 54.7088 42.551 46.6265 28.5521C38.5443 14.5533 25.4406 6.98761 17.3586 11.6537C9.2766 16.3199 9.27681 31.4509 17.3591 45.4497C25.4413 59.4486 38.545 67.0143 46.627 62.3481Z",
    fill: "#F3F3F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2731 62.282C42.7708 63.4017 38.3718 62.7417 33.5876 59.9833C22.1591 53.3849 12.9053 37.3305 12.9053 24.1356C12.9053 18.2258 14.7671 13.8917 17.8498 11.4996C17.9643 11.4118 18.0787 11.3222 18.197 11.2363C18.0654 11.2955 17.9376 11.3641 17.8097 11.4309C13.8152 13.4797 11.3201 18.2086 11.3201 25.0531C11.3201 38.2499 20.5853 54.2986 32.0023 60.897C37.584 64.1247 42.6563 64.4891 46.3819 62.4823C46.7348 62.2934 47.0762 62.0817 47.4024 61.8489C47.0362 62.0168 46.6585 62.1618 46.2731 62.282Z",
    fill: "url(#paint2_linear_29_230391)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5763 59.9814C22.1478 53.3829 12.894 37.3285 12.894 24.1336C12.894 18.2238 14.7558 13.8898 17.8385 11.4976C17.953 11.4099 18.0674 11.3202 18.1857 11.2344C18.0541 11.2935 17.9263 11.3622 17.7985 11.429C13.802 13.4777 11.3069 18.2048 11.3069 25.0493C11.3069 38.2461 20.5721 54.2948 31.9892 60.8932C37.5708 64.1209 42.6431 64.4852 46.3687 62.4784C46.7216 62.2896 47.0631 62.0778 47.3893 61.8451C47.0211 62.0149 46.6434 62.1598 46.2561 62.2819C42.7557 63.4017 38.3567 62.7417 33.5744 59.9814H33.5763Z",
    fill: "url(#paint3_linear_29_230391)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0115 34.6833C38.0115 38.5176 35.316 40.0742 31.993 38.1533C28.6699 36.2323 25.9783 31.5701 25.9783 27.7358C25.9783 23.9015 28.6737 22.3449 31.993 24.2621C35.3122 26.1792 38.0115 30.8452 38.0115 34.6814V34.6833Z",
    fill: "#A0A0A0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1511 43.1164L26.8367 37.1608C25.448 36.3597 24.2595 37.0464 24.2595 38.6507V41.6285L39.7283 50.558V47.5802C39.7283 45.974 38.5399 43.9157 37.1511 43.1145V43.1164Z",
    fill: "#A0A0A0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_29_230391",
    x1: 27.5521,
    y1: 52.929,
    x2: 52.3166,
    y2: 10.0422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_29_230391",
    x1: 9.72196,
    y1: 37.0002,
    x2: 54.2608,
    y2: 37.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEBEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_29_230391",
    x1: 11.3201,
    y1: 37.4793,
    x2: 47.4024,
    y2: 37.4793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_29_230391",
    x1: 11.3069,
    y1: 37.4754,
    x2: 47.3912,
    y2: 37.4754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDCDC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoIdentity);
export default __webpack_public_path__ + "static/media/no_identity.a8052d1beb2452c1f01e856ce728b29a.svg";
export { ForwardRef as ReactComponent };